import { Flex, InlineStack, PanelHeader } from '@customerio/pluma-components/react';
import { TableListCount } from '@/features/people';
import { RelationshipsTableActions } from './relationships-table-actions';

type RelationshipsTableHeaderProps = {
  /** Lowercase people noun, as the count copy reads mid-sentence. */
  countNoun: string;
  /** Every relationship the object has; `-1` until the first page resolves. */
  total: number;
  selectedCount: number;
  isAllSelected: boolean;
  isPageSelected: boolean;
  canDelete: boolean;
  onClearSelection: () => void;
  onDeleteSelected: () => void;
  onDeleteAll: () => void;
};

export function RelationshipsTableHeader({
  countNoun,
  total,
  selectedCount,
  isAllSelected,
  isPageSelected,
  canDelete,
  onClearSelection,
  onDeleteSelected,
  onDeleteAll,
}: RelationshipsTableHeaderProps) {
  return (
    <PanelHeader>
      <Flex w="full" alignItems="center" flexWrap="wrap" gap="150">
        <InlineStack gap="150" alignBlock="center">
          <TableListCount
            allSelected={isAllSelected}
            totalCount={total}
            selectedCount={selectedCount}
            singularName={countNoun}
          />
          <RelationshipsTableActions
            selectedCount={selectedCount}
            total={total}
            canDelete={canDelete}
            isPageSelected={isPageSelected}
            onClearSelection={onClearSelection}
            onDeleteSelected={onDeleteSelected}
            onDeleteAll={onDeleteAll}
          />
        </InlineStack>
      </Flex>
    </PanelHeader>
  );
}
